import { router } from "./router";
import { title } from "@/config";
import store from "@/store";
import { getToken } from "@/libs/auth.js";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style

const titleName = titleText => {
  window.document.title = ("SISU | 中国话语与世界文学研究中心 - ") + titleText || title;
};

NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

router.beforeEach((to, from, next) => {
  NProgress.start();
  titleName(to.meta.title); // 替换标签title
  next();
});

router.afterEach(() => {
  NProgress.done();
});
